import MatomoMessage from '@/matomo/message/MatomoMessage';
import { MatomoActions } from '@/matomo/MatomoActions';

export default class MatomoPageVisit {
  private setDocumentTitle = new MatomoMessage([MatomoActions.setDocumentTitle]);
  private trackPageView = new MatomoMessage([MatomoActions.trackPageView]);

  public static withDocumentTitle(additionalKey: string): MatomoPageVisit {
    return new MatomoPageVisit(document.title + '-' + additionalKey);
  }

  public constructor(title: string) {
    this.setDocumentTitle = this.setDocumentTitle.with(title);
  }

  public publishPageVisit() {
    this.setDocumentTitle.publish();
    this.trackPageView.publish();
  }


}
